import React, { Component, Fragment } from 'react'
import { connect } from 'react-redux'
import { requestSignBox } from 'portal-modules/documents/redux/modules/documents'
import { SignService } from 'portal-modules/documents/components'
import PropTypes from 'prop-types'
import styled from '@emotion/styled'
import { css } from 'emotion'

const StyledSignBoxDiv = css`
    position:absolute;
    overflow: hidden;
    text-overflow: ellipsis;
    color: #858585 !important;
    background: #cae4fb !important;
    border: 1px solid rgb(40 145 239) !important;
    border-radius: 0 !important;
    opacity: .7 !important;
    cursor: pointer;
    white-space: nowrap;
    text-align: center !important;
    box-shadow: none !important;
    padding: 0 !important;

    /* Safari/WebKit specific fixes for iOS visibility */
    -webkit-transform: translate3d(0, 0, 0);
    transform: translate3d(0, 0, 0);
    -webkit-backface-visibility: hidden;
    backface-visibility: hidden;
    will-change: transform;
    z-index: 10;

    /* Ensure the element is treated as a block for iOS Safari */
    display: block;

    /* iOS Safari specific visibility fix */
    -webkit-appearance: none;
    appearance: none;
`

const StyledSignatureDiv = styled.div(props => ({
  position:'absolute',
  color: '#858585',
  background: '#dbebce',
  border: '1px solid #70ad3b',
  borderRadius: '0',
  opacity: '.7',
  padding: '0',
  paddingLeft: '5px',
  left: props.left,
  top:props.top,
  width:props.width,
  height:props.height,
  lineHeight:props.lineHeight,
  fontSize:props.fontSize,

  // Safari/WebKit specific fixes for iOS visibility
  WebkitTransform: 'translate3d(0, 0, 0)',
  transform: 'translate3d(0, 0, 0)',
  WebkitBackfaceVisibility: 'hidden',
  backfaceVisibility: 'hidden',
  willChange: 'transform',
  zIndex: 10,
  display: 'block',
  WebkitAppearance: 'none',
  appearance: 'none',

}))



const StyledSignatureImage = styled('img')`
max-width : 100%;
max-height: 100%
`

class SignBox extends Component {
  constructor(props) {
    super(props)

    this.state = {
      signBox: props.signBox,
    }


  }

  handleSignBoxModalOpen = null

  setModelOpen =( handler ) => {
    this.handleSignBoxModalOpen = handler
  }

  handleSignBox = ( valuePair ) => {
    const { requestSignBox } = this.props
    const { signBox } = this.state

    const sign = {
      id : (signBox?.parent_file_id) || signBox.file_id,
      child_file_id : signBox.file_id,
      mergefield_id : signBox.mergefield_id,
      box_id : signBox.box_id,
      mergefield_name : signBox.mergefield_name,
      ...valuePair,
    }
    //will update later
    requestSignBox({
      payload: sign,
      callback: ( is_signed ) => {
        if( is_signed ) {
          let { signBox } = this.state
          signBox.is_signed = is_signed
          this.setState({ signBox: signBox })
        }
      }
    })
  }

  render() {

    const {y_pos, x_pos, width, height, is_signed, box_id, is_initials_only } = this.state.signBox
    const standardWidth = 1200
    let scaleRatio = standardWidth / this.props.pageWidth

    let top =  ( y_pos / scaleRatio ) + 'px'
    let left = ( x_pos / scaleRatio ) + 'px'
    let boxWidth =  ( width / scaleRatio ) + 'px !important'
    let boxHeight = ( height / scaleRatio ) + 'px'
    let lineHeight = boxHeight
    let fontSize = 100 / scaleRatio
    fontSize =  ( fontSize > 100 ? '100%' : fontSize + '%' ) + ' !important'

    return (
      <Fragment>
        { !is_signed  ? (
        <SignService
            key={box_id}
            label={__('Click to Sign')}
            onDigitalSignModalOpen={this.setModelOpen}
            requireFullName={!is_initials_only}
            onSign={this.handleSignBox}
            className={css`${StyledSignBoxDiv}; left: ${left}; top: ${top}; width: ${boxWidth}; height: ${boxHeight}; line-height: ${lineHeight}; font-size: ${fontSize};`}
            onClick={this.handleSignBoxModalOpen}
          />
        ) : (
          <StyledSignatureDiv left={left} top={top} width={boxWidth} height={boxHeight} lineHeight={lineHeight} fontSize={fontSize}>
          <StyledSignatureImage src={this.props.signatureImage} />
          </StyledSignatureDiv>
        )}
      </Fragment>

    )
  }

}

SignBox.propTypes = {
  signBox: PropTypes.object.isRequired,
  requestSignBox: PropTypes.func.isRequired,
}

export default connect(({ user }) => {
  return {
    token: user.token,
  }
},{requestSignBox}
)(SignBox)